import { render, staticRenderFns } from "./TrailPage.vue?vue&type=template&id=4f12e23d"
import script from "./TrailPage.vue?vue&type=script&lang=js"
export * from "./TrailPage.vue?vue&type=script&lang=js"
import style0 from "./TrailPage.vue?vue&type=style&index=0&id=4f12e23d&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports